var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",class:{
    'flex-col gap-4': !_vm.inline,
    'flex-row items-start gap-8 flex-wrap': _vm.inline,
  },attrs:{"role":"radiogroup","aria-labelledby":("group_label_" + _vm.name)}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }